import * as types from "./types";

export default {
  [types.CSAT_SURVEY](state, payload) {
      state.csatSurvey = payload;
    },
};
